<template>
  <soha-modal
    id="questExpert"
    :title="$t(`${I18nPrefix}TITLE`)"
    @hide="clearModalData"
  >
    <template #activator />
    <template #body>
      <soha-text-field
        v-model="username.value"
        name="username"
        :error="username.error"
        class="w-100 my-3"
        :placeholder="$t(`${I18nPrefix}USERNAME`)"
      />
      <soha-text-field
        v-model="time.value"
        name="time"
        :error="time.error"
        type="number"
        class="w-100 my-3"
        :placeholder="$t(`${I18nPrefix}TIME_PLACEHOLDER`)"
      />
    </template>
    <template #footer>
      <soha-button
        name="sendLink"
        variant="primary"
        :text="$t(`${I18nPrefix}SEND_LINK`)"
        :loading="loading"
        @btn-click="sendLink"
      />
    </template>
  </soha-modal>
</template>

<script>
import ApiService from "@/core/services/api.service";
import ValidationMixin from "@/mixins/ValidationMixin";
import UIMixin from "@/mixins/UIMixin";

export default {
  name: "ResumeModalGuestExpert",

  mixins: [ValidationMixin, UIMixin],

  props: {
    resumeId: null,
  },

  data() {
    return {
      I18nPrefix: "COMPONENTS.RESUME.RESUME_GUEST_EXPERT_MODAL.",
      loading: false,
      username: {
        value: null,
        error: null,
      },
      time: {
        value: null,
        error: null,
      },
    };
  },

  methods: {
    sendLink() {
      this.username.error = this.validateUsername(this.username.value);
      this.time.error = this.validateField(
        this.time.value,
        this.$t(`${this.I18nPrefix}TIME`)
      );
      if (!this.username.error && !this.time.error) {
        this.loading = true;
        ApiService.post(`api/v2/resumes/${this.resumeId}/guest-links`, {
          username: this.username.value,
          duration: this.time.value,
        }).then(({ data }) => {
          if (+data.code === 207 || +data.code === 209) {
            this.successToast(data.message);
            this.$modal.hide("questExpert");
          } else {
            this.errorToast(data.message);
          }
          this.loading = false;
        });
      }
    },

    clearModalData() {
      this.username = {
        value: null,
        error: null,
      };
      this.time = {
        value: null,
        error: null,
      };
    },
  },
};
</script>

<style scoped></style>
